import { render, staticRenderFns } from "./realName.vue?vue&type=template&id=4b78e713"
import script from "./realName.vue?vue&type=script&lang=js"
export * from "./realName.vue?vue&type=script&lang=js"
import style0 from "./realName.vue?vue&type=style&index=0&id=4b78e713&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b78e713')) {
      api.createRecord('4b78e713', component.options)
    } else {
      api.reload('4b78e713', component.options)
    }
    module.hot.accept("./realName.vue?vue&type=template&id=4b78e713", function () {
      api.rerender('4b78e713', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claimWorkOrder/setCollectAccountByQuick/realName.vue"
export default component.exports